/**
 * 统一错误提示。单独成文件是为了：
 *  1. 让 request.ts 与 UI 组件解耦，便于单元测试时替换；
 *  2. 保证 traceId 一定出现在提示里（用户报错时要求提供此值）。
 */
import { ElMessage } from 'element-plus'
import type { ApiError } from '@/api/errors'

export type ErrorNotifier = (text: string) => void

let notifier: ErrorNotifier = (text: string) => {
  ElMessage({ type: 'error', message: text, duration: 6000, showClose: true })
}

export function setErrorNotifier(fn: ErrorNotifier | null): void {
  notifier =
    fn ??
    ((text: string) => {
      ElMessage({ type: 'error', message: text, duration: 6000, showClose: true })
    })
}

/** 展示一个 ApiError；traceId 存在时一并展示 */
export function notifyError(err: ApiError): void {
  notifier(err.toDisplayText())
}

export function notifySuccess(text: string): void {
  ElMessage({ type: 'success', message: text, duration: 2500 })
}

export function notifyWarning(text: string): void {
  ElMessage({ type: 'warning', message: text, duration: 4000, showClose: true })
}
